import { TABS_SET_ACTIVID } from "../constants/tabs.constants"

export const changeActiveId = (activeId, tabsId) => ({
    type: TABS_SET_ACTIVID,
    activeId,
    tabsId
})